/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

import { connect, useSelector } from "react-redux";
import useWindowSize from "../hooks/WindowResizer";
import SideBar from "./SideBar";
import MobileViewHeader from "./MobileViewHeader";

const FastRealtyV2 = (props) => {
  const token = useSelector((state) => state.token);
  const page = props["page"] || "Magic_Emails";
  const url = `https://streamlit-pocs.onrender.com/${page}?token=${token}&embed=true&embed_options=light_theme`;

  const isMobileView = useWindowSize();

  return (
    <div className="fastRealtyV2-root">
      {!isMobileView && <SideBar />}

      <div className="me">
        {isMobileView && <MobileViewHeader />}

        <iframe
          src={url}
          style={{ height: "100vh", width: "100%" }}
          className="iframe"
        ></iframe>
      </div>

      <style>
        {`.makeStyles-App_root-3 {
        background: #F0F2F5 !important;
      }
      `}
      </style>
    </div>
  );
};

export default connect((state) => ({}))(FastRealtyV2);
